import comp from "./InlineEditText";
export default comp;
